import { Download, Upload } from "@mui/icons-material";
import { Backdrop, Checkbox, CircularProgress, Stack } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { enqueueSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TLinkApi from "services/tlink.api";
import DataTable from "comps/Tables/DataTable";
import { Header } from "antd/es/layout/layout";
import { set } from "react-hook-form";

const Recontact = () => {
  const { id } = useParams();
  const [entriesPerPage, setEntriesPerPage] = useState(50);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [totalLength, setTotalLength] = useState(0);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [file, setFile] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);

  const onChange = (file) => {
    setFile(file);
  };
  const handleUpload = async () => {
    try {
      setIsLoading(true);
      let formData = new FormData();
      formData.append("file", file);
      const data = await TLinkApi.post(
        `/survey/${id}/recontact-respondent`,
        formData,
      );
      setFile("");
      await getData();
      setIsLoading(false);
    } catch (e) {
      enqueueSnackbar(
        e?.response?.data?.message || "There is something went.",
        {
          variant: "error",
        },
      );
      console.log(e);
      setIsLoading(false);
    }
  };

  const getData = async () => {
    try {
      setIsLoading(true);
      const { data } = await TLinkApi.get(
        `/survey/${id}/recontact-respondent?size=${entriesPerPage}&page=${page}&search=${search}`,
      );
      setRows(data?.items || []);
      setTotalLength(data?.totalTokens || 0);
      setIsLoading(false);
    } catch (e) {
      enqueueSnackbar(
        e?.response?.data?.message || "There is something went.",
        {
          variant: "error",
        },
      );
      console.log(e);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => getData(), 500);
    return () => clearTimeout(timer);
  }, [entriesPerPage, page, id, search]);

  const handleActivate = async () => {
    try {
      setIsLoading(true);
      await TLinkApi.put(`/survey/${id}/recontact-respondent/activate`, {
        tokens: selectedRows,
      });
      enqueueSnackbar("Selected respondents have been activated.", {
        variant: "success",
      });
      setSelectedRows([]);
      await getData();
      setIsLoading(false);
    } catch (e) {
      enqueueSnackbar(
        e?.response?.data?.message || "There is something went.",
        {
          variant: "error",
        },
      );
      console.log(e);
      setIsLoading(false);
    }
  };
  const handleDeactivate = async () => {
    try {
      setIsLoading(true);
      await TLinkApi.put(`/survey/${id}/recontact-respondent/deactivate`, {
        tokens: selectedRows,
      });
      enqueueSnackbar("Selected respondents have been activated.", {
        variant: "success",
      });
      setSelectedRows([]);
      await getData();
      setIsLoading(false);
    } catch (e) {
      enqueueSnackbar(
        e?.response?.data?.message || "There is something went.",
        {
          variant: "error",
        },
      );
      console.log(e);
      setIsLoading(false);
    }
  };

  let columns = [
    {
      accessor: "id",
      align: "left",
      Header: "Select",
      sortable: false,
      Cell: ({ row }) => {
        const token = row?.original?.token;

        const handleChange = () => {
          setSelectedRows((prev) =>
            prev.includes(token)
              ? prev.filter((t) => t !== token)
              : [...prev, token],
          );
        };

        return (
          <Stack direction="row" alignItems="center" gap="0.5rem">
            <Checkbox
              checked={selectedRows.includes(token)}
              size="small"
              onChange={handleChange}
            />
          </Stack>
        );
      },
    },
    {
      accessor: "token",
      Header: "Token",
      align: "left",
      headerAlign: "center",
    },
    {
      accessor: "supplierId",
      Header: "Supplier Id",
      align: "left",
      headerAlign: "center",
    },
    {
      accessor: "supplierName",
      Header: "Supplier Name",
      align: "left",
      headerAlign: "center",
    },
    {
      accessor: "supplierToken",
      Header: "Supplier Token",
      align: "left",
      headerAlign: "center",
    },
    {
      accessor: "statusName",
      Header: "Status Name",
      align: "left",
      headerAlign: "center",
    },
    {
      accessor: "subStatusName",
      Header: "Sub Status Name",
      align: "left",
      headerAlign: "center",
    },
    {
      accessor: "isMatched",
      Header: "Matched",
      sortable: true,
      align: "left",
      headerAlign: "left",
      Cell: ({ row }) => {
        return row?.original?.isMatched ? "True" : "False";
      },
    },
    {
      accessor: "isActive",
      Header: "Is Active",
      align: "center",
      sortable: true,
      headerAlign: "center",
      Cell: ({ row }) => {
        return row?.original?.isActive ? "Active" : "Inactive";
      },
    },
  ];

  const downloadCSV = async () => {
    try {
      setIsLoading(true);
      const { data } = await TLinkApi.get(
        `/survey/${id}/recontact-respondent/download`,
        {
          responseType: "blob", // important
        },
      );

      const uint8Array = new Uint8Array(data?.data);
      const blob = new Blob([uint8Array], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "data.csv"; // file name
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      enqueueSnackbar(
        error?.response?.data?.message || "There is something went.",
        {
          variant: "error",
        },
      );
      console.error("Download error:", error);
    }
  };

  console.log(file,"file");

  return (
    <div style={{ paddingTop: "8px" }}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MDBox
        sx={{
          background: "#fff",
          height: "calc(100vh - 180px) !important",
          padding: "1rem",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          gap="1rem"
        >
          <Stack direction="row" alignItems="center" gap="1rem">
            <MDButton
              variant="outlined"
              color="dark"
              size="small"
              sx={{
                borderColor: "#d2d6da",
                height: "36px",
                borderRadius: "0.3rem",
                boxShadow: "none !important",
                "&:focus:not(:hover)": {
                  boxShadow: "none !important",
                },
              }}
              href="/Sample_Data_For_Reconnet.xlsx"
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between !important"
                width="100%"
                gap="0.5rem"
              >
                Sample File
                <Download sx={{ fontSize: "1rem" }} />
              </Stack>
            </MDButton>
            <>
              <MDButton
                variant="outlined"
                color="dark"
                size="small"
                sx={{
                  borderColor: "#d2d6da",
                  height: "36px",
                  borderRadius: "0.3rem",
                  boxShadow: "none !important",
                  "&:focus:not(:hover)": {
                    boxShadow: "none !important",
                  },
                }}
                htmlFor="files"
                onClick={() => {
                  document.getElementById("files").click();
                }}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between !important"
                  width="100%"
                  gap="0.5rem"
                >
                  <span>{file && file !== "" ? file?.name : "Upload file"}</span>
                  <Upload sx={{ fontSize: "1rem" }} />
                </Stack>
              </MDButton>
              <input
                id="files"
                onChange={(e) => {
                  onChange(e.target.files[0]);
                }}
                required
                type="file"
                style={{ display: "none" }}
                label="File Upload"
                autoComplete="off"
                accept=".xlsx"
                variant="outlined"
              />
            </>
            <MDButton
              variant="gradient"
              color="dark"
              size="small"
              disabled={file === ""}
              sx={{
                height: "36px",
                borderRadius: "0.3rem",
                boxShadow: "none !important",
                "&:focus:not(:hover)": {
                  boxShadow: "none !important",
                },
              }}
              onClick={() => {
                handleUpload();
              }}
            >
              Upload
            </MDButton>
          </Stack>
          <Stack direction="row" alignItems="center" gap="1rem">
            <MDButton
              variant="outlined"
              color="dark"
              size="small"
              sx={{
                borderColor: "#d2d6da",
                height: "36px",
                borderRadius: "0.3rem",
                boxShadow: "none !important",
                "&:focus:not(:hover)": {
                  boxShadow: "none !important",
                },
              }}
              onClick={() => {
                downloadCSV();
              }}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between !important"
                width="100%"
                gap="0.5rem"
              >
                Download
                <Download sx={{ fontSize: "1rem" }} />
              </Stack>
            </MDButton>
            <MDButton
              variant="gradient"
              color="dark"
              size="small"
              disabled={selectedRows.length === 0}
              sx={{
                height: "36px",
                borderRadius: "0.3rem",
                boxShadow: "none !important",
                "&:focus:not(:hover)": {
                  boxShadow: "none !important",
                },
              }}
              onClick={() => {
                handleActivate();
              }}
            >
              Activate
            </MDButton>
            <MDButton
              variant="gradient"
              color="dark"
              size="small"
              disabled={selectedRows.length === 0}
              sx={{
                height: "36px",
                borderRadius: "0.3rem",
                boxShadow: "none !important",
                "&:focus:not(:hover)": {
                  boxShadow: "none !important",
                },
              }}
              onClick={() => {
                handleDeactivate();
              }}
            >
              Deactivate
            </MDButton>
          </Stack>
        </Stack>
        <DataTable
          table={{ columns, rows }}
          isSorted
          noEndBorder
          entriesPerPage={entriesPerPage}
          canSearch={true}
          tablePage={page}
          onSearchChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
          setTablePage={setPage}
          setEntriesPerPage={setEntriesPerPage}
          totalLength={totalLength}
          pagination={true}
          entriesOption={[50, 100, 200]}
          tableMaxHeight={"calc(100vh - 380px)"}
          tableMinHeight={"calc(100vh - 380px)"}
        />
      </MDBox>
    </div>
  );
};

export default Recontact;
